export default {
      id: "list-check-mark-usage",
      viewBox: "0 0 16 12",
      url: __webpack_public_path__ + "sprite.svg#list-check-mark-usage",
      toString: function () {
        return this.url;
      }
    }